module.exports = __webpack_public_path__ + "img/img-3.40988843.svg";